import React, { ChangeEvent, FC, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { validatePhoneNumber } from '@qred/shared-component-library/src/validators';
import { setInvalidError, setMissingError } from '~/actions/errorActions';
import { setInput, validateValue } from '~/actions/formActions';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';
import { IState } from '~/sharedInterfaces/IState';
import { PHONE_NUMBER } from '~/actions/actionTypes';
import { IBaseInput } from '~/sharedInterfaces/SharedInterfaces';
import Input from '../Base/Input/Input';

export interface IPhoneNumber extends IBaseInput {}
interface IPhoneNumberProps extends IPhoneNumber, IBaseComponent {}

const PhoneNumber: FC<IPhoneNumberProps> = (props) => {
  const dispatch = useDispatch();

  const value = useSelector((state: IState) => state.signup.phoneNumber || '');
  const error = useSelector((state: IState) => state.error.phoneNumber);
  const { locale } = useSelector((state: IState) => state.widgetContext);

  const handleValidation = () => {
    dispatch(validateValue(validatePhoneNumber, PHONE_NUMBER, value, locale));
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    dispatch(setInput(PHONE_NUMBER, inputValue));
    if (error) dispatch(setMissingError(PHONE_NUMBER, ''));
  };

  useEffect(() => {
    const validPhoneNumber = validatePhoneNumber(value, props.settings.market);
    if (validPhoneNumber && error?.invalid) dispatch(setInvalidError(PHONE_NUMBER, ''));
  }, [value]);

  return (
    <Input
      {...props}
      value={value}
      error={error ? error.missing || error.invalid : ''}
      handleValidation={handleValidation}
      onChange={handleOnChange}
      analyticsEvent="phoneNumber"
      inputMode="tel"
    />
  );
};

export default PhoneNumber;
